<template>
  <div>
    <vs-card class="card_content_pb_0">
      <div class="flex items-center justify-between" slot="header">
        <div class="inline-flex items-center">
          <vs-button
            type="border"
            @click="backToProject"
            icon="chevron_left"
          ></vs-button>
          <h4 class="ml-2">{{ projectDetails.name }}</h4>
        </div>
        <!-- <vs-button
          @click="reorderStatus = true"
          v-if="checkProjectEditPermission()"
          >Reorder Boards</vs-button
        > -->
        <vs-dropdown
          style="float: right; cursor: pointer"
          vs-custom-content
          vs-trigger-click
        >
          <vs-button
            color="primary"
            type="border"
            icon-pack="feather"
            icon="icon-more-vertical"
          ></vs-button>

          <vs-dropdown-menu>
            <vs-dropdown-item
              @click="reorderStatus = true"
              v-if="checkProjectEditPermission()"
              >Reorder Boards</vs-dropdown-item
            >
            <vs-dropdown-item
              @click="warningPopup"
              v-if="
                checkProjectEditPermission() &&
                projectDetails.platform_project_completion_status.id != 3
              "
              >Complete Project</vs-dropdown-item
            >
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
      <div>
        <p>{{ projectDetails.details }}</p>
      </div>
      <div class="flex items-center my-4">
        <div
          v-if="
            projectDetails.userProjectMember.length !== 0 ||
            projectDetails.clientProjectMember.length !== 0
          "
          class="flex justify-flex-end"
        >
          <div
            class="cstm-img-holder"
            v-for="(pic, index2) in projectDetails.clientProjectMember.concat(
              projectDetails.userProjectMember
            )"
            :key="index2"
          >
            <vs-tooltip
              v-if="pic.picture !== ''"
              :text="pic.first_name + ' ' + pic.last_name"
            >
              <img
                :src="pic.picture"
                alt="user-img"
                width="20"
                height="20"
                class="rounded-full shadow-md cursor-pointer block"
              />
            </vs-tooltip>
            <vs-tooltip v-else :text="pic.first_name + ' ' + pic.last_name">
              <img
                src="@/assets/images/pages/user-circle-solid.svg"
                alt="user-img"
                width="20"
                height="20"
                class="rounded-full shadow-md cursor-pointer block"
              />
            </vs-tooltip>
          </div>
        </div>
        <div class="date_container">
          <feather-icon icon="CalendarIcon" />
          <label>Due Date</label>
          <!-- <vs-input class="ml-2" :value="projectDetails.due_date.split(' ')[0]" readonly/> -->
        </div>
        <flat-pickr
          class="dateformatChng w_210_input"
          v-model="projectDetails.due_date"
          :config="configdateTimePicker1"
          disabled
        />
      </div>
      <vs-divider />
      <div
        style="height: calc(100vh - 350px)"
        class="task-kanban-holder project_details_kanban"
      >
        <div :key="item.id" v-for="item in projectDetailsData">
          <div class="flex flex-wrap justify-between">
            <div class="heading_title">
              <h4>{{ item.name }}</h4>
            </div>
            <ExtraActionProject
              v-if="checkProjectEditPermission()"
              :projectDetailsId="$route.params.id"
              :statusNameFromButton="item"
              @updateKanbanBoard="updateKanbanBoard($event)"
              @updateStatusName="updateStatusName($event)"
              @removeStatus="removeStatus($event)"
            />
          </div>
          <draggable
            group="id"
            :list="item.tasks"
            :id="item.id"
            :move="checkMove"
            @end="handleKanbanReorder"
            class="w-full py-2 cursor-move"
          >
            <!-- <div v-if="item.tasks.length !== 0"> -->
            <div :key="taskListing.id" v-for="taskListing in item.tasks">
              <div style="cursor: default" class="card-holder">
                <div class="flex justify-between items-center mb-4">
                  <h6>{{ taskListing.name }}</h6>
                  <vs-tooltip color="primary" text="View" position="bottom">
                    <feather-icon
                      icon="EyeIcon"
                      style="width: 16px; cursor: pointer"
                      @click="
                        openModalSectionLiveFromProject(
                          taskListing,
                          item.id,
                          'View'
                        )
                      "
                    />
                  </vs-tooltip>
                </div>
                <p class="content mb-4">{{ taskListing.details }}</p>
                <div class="name-badge-holder">
                  <!-- <p class="name">{{userInfo.first_name}}</p> -->
                  <!-- <span
                    class="task-cstm-badge"
                    :class="['badge-' + taskListing.status.id]"
                  >
                    {{ taskListing.status.status }}
                  </span> -->
                  <!-- {{taskListing}} -->
                  <v-select
                    label="status"
                    @input="
                      handleStatusChnage(taskListing.id, taskListing.status.id)
                    "
                    append-to-body
                    v-model="taskListing.status.id"
                    class="task-cstm-badge cstm_vue_select p-0"
                    :class="['badge-' + taskListing.status.id]"
                    :options="options"
                    :reduce="(option) => option.id"
                    :clearable="false"
                    :searchable="false"
                    style="width: 120px"
                  >
                  </v-select>
                </div>
                <div class="kanban-icon-holder">
                  <div>
                    <div
                      class="mr-2"
                      v-if="
                        taskListing.due_date != null &&
                        taskListing.due_date != ''
                      "
                    >
                      <feather-icon icon="ClockIcon" />
                      <!-- <span>{{taskListing.due_date.split(' ')[0]}}</span> -->
                      <flat-pickr
                        class="dateformatChng"
                        v-model="taskListing.due_date"
                        :config="configdateTimePicker3"
                        disabled
                      />
                    </div>

                    <!-- <div class="mr-2">
                                    <feather-icon icon="LinkIcon" />
                                    <span>1</span>
                                </div> -->
                  </div>

                  <div
                    v-if="taskListing.task_priority.id === 2"
                    class="mediumPriority"
                  >
                    <feather-icon icon="ArrowUpIcon" />
                  </div>
                  <div
                    v-if="taskListing.task_priority.id === 1"
                    class="highPriority"
                  >
                    <feather-icon icon="ArrowUpIcon" />
                  </div>
                  <div v-if="taskListing.task_priority.id === 3">
                    <feather-icon color="success" icon="ArrowUpIcon" />
                  </div>
                  <div v-if="taskListing.task_priority.id === 4">
                    <feather-icon color="success" icon="ArrowUpIcon" />
                  </div>
                </div>
                <div class="flex flex-wrap items-center my-4">
                  <div class="inline-flex flex-wrap w-4/5">
                    <!-- <pre> {{taskListing}} </pre>  -->
                    <div
                      v-if="taskListing.taskResponsiblePerson !== ''"
                      class="flex"
                    >
                      <vs-tooltip
                        v-if="taskListing.userResponsiblePerson[0]"
                        :text="taskListing.taskResponsiblePerson"
                      >
                      <div  v-if="taskListing.userResponsiblePerson[0].picture">
                        <img
                          :src="taskListing.userResponsiblePerson[0].picture"
                          alt="user-img"
                          width="20"
                          height="20"
                          class="rounded-full shadow-md cursor-pointer block"
                        />
                      </div>

                      </vs-tooltip>
                       <vs-tooltip
                        v-else
                        :text="taskListing.taskResponsiblePerson"
                      >
                        <img
                          src="@/assets/images/pages/user-circle-solid.svg"
                          alt="user-img"
                          width="20"
                          height="20"
                          class="rounded-full shadow-md cursor-pointer block"
                        />
                      </vs-tooltip>
                    </div>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <div
                      v-if="
                        taskListing.clientParticipant.length !== 0 ||
                        taskListing.userParticipant.length !== 0
                      "
                      class="flex justify-flex-end"
                    >
                      <div
                        class="cstm-img-holder"
                        v-for="(
                          pic, index2
                        ) in taskListing.clientParticipant.concat(
                          taskListing.userParticipant
                        )"
                        :key="index2"
                      >
                        <vs-tooltip
                          v-if="pic.picture !== '' && pic.picture !== null"
                          :text="pic.first_name + ' ' + pic.last_name"
                        >
                          <img
                            :src="pic.picture"
                            alt="user-img"
                            width="20"
                            height="20"
                            class="rounded-full shadow-md cursor-pointer block"
                          />
                        </vs-tooltip>
                        <vs-tooltip
                          v-else
                          :text="pic.first_name + ' ' + pic.last_name"
                        >
                          <img
                            src="@/assets/images/pages/user-circle-solid.svg"
                            alt="user-img"
                            width="20"
                            height="20"
                            class="rounded-full shadow-md cursor-pointer block"
                          />
                        </vs-tooltip>
                      </div>
                    </div>
                  </div>
                  <div class="inline-flex flex-wrap justify-end w-1/5">
                    <vs-tooltip
                      color="primary"
                      text="Edit"
                      position="top"
                      class="mr-1"
                    >
                      <feather-icon
                        icon="EditIcon"
                        style="width: 16px; cursor: pointer"
                        @click="
                          openModalSectionLiveFromProject(
                            taskListing,
                            item.id,
                            'Edit'
                          )
                        "
                      />
                    </vs-tooltip>
                    <vs-tooltip color="danger" text="Delete" position="top">
                      <feather-icon
                        icon="Trash2Icon"
                        style="width: 16px; cursor: pointer"
                        @click="checkTask(taskListing.id)"
                      />
                    </vs-tooltip>
                  </div>
                </div>
              </div>
            </div>
            <!-- </div> -->
          </draggable>
        </div>
        <vs-prompt
          title="Delete Task"
          @cancel="checkTaskDel = false"
          @accept="RemoveTask"
          @close="close"
          :active.sync="checkTaskDel"
        >
          <div class="con-exemple-prompt">
            <span>Are you sure to remove this task from this project?</span>
          </div>
        </vs-prompt>

        <vs-tooltip
          class="addBoardTooltip"
          color="primary"
          text="Add Board"
          position="top"
        >
          <vs-button
            v-if="checkProjectEditPermission()"
            type="border"
            class="addBoardbtn"
            icon="add"
            @click="addBoardPopup = true"
          ></vs-button>
        </vs-tooltip>
      </div>
      <!-- <vs-button
        class="block ml-auto mt-4"
        @click="warningPopup"
        v-if="
          checkProjectEditPermission() &&
          projectDetails.platform_project_completion_status.id != 3
        "
        >Complete Project</vs-button
      > -->
    </vs-card>
    <vs-popup
      class="reorderPopup"
      title="Reorder Boards"
      :active.sync="reorderStatus"
    >
      <draggable :list="projectDetailsData" class="w-full cursor-move">
        <div
          :key="item.id"
          v-for="item in projectDetailsData"
          class="task-cstm-badge w-full flex items-center justify-between"
        >
          <h4 class="text-center">{{ item.name }}</h4>
        </div>
      </draggable>
      <vs-button class="block ml-auto mt-4" @click="saveTheReorder('reorder')"
        >Save</vs-button
      >
    </vs-popup>
    <vs-popup title="Add Board Name" :active.sync="addBoardPopup">
      <vs-input
        placeholder="Type and enter to add board name"
        v-model="addedStatus"
        @keyup.native.enter="addStatusInProject"
        class="w-full"
      />
    </vs-popup>
    <vs-popup title="Please Confirm" :active.sync="warningPopupShow">
      <vs-row>
        <span>Do you want to complete this project?</span>
      </vs-row>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-4">
        <vs-button
          @click="checkStatus"
          type="filled"
          class="mr-2 vs-con-loading__container"
          >Yes</vs-button
        >
        <vs-button @click="warningPopupShow = false" type="border"
          >No</vs-button
        >
      </vs-row>
    </vs-popup>
    <vs-popup title="Complete Project" :active.sync="warningPopupShow2">
      <div class="statusData-holder flex">
        <div
          @click="tabView('todo')"
          class="inline-flex items-center todo"
          :class="{ activeTab: todoTab }"
        >
          <h5 class="mr-1">Todo</h5>
          <span
            class="task-cstm-badge badge-1"
            v-if="this.statusData.length > 0"
            >{{ this.todo.length }}</span
          >
        </div>
        <div
          @click="tabView('progress')"
          class="inline-flex items-center progress"
          :class="{ activeTab: progressTab }"
        >
          <h5 class="mr-1">In Progress</h5>
          <span
            class="task-cstm-badge badge-2"
            v-if="this.statusData.length > 0"
            >{{ this.inProgress.length }}</span
          >
        </div>
      </div>
      <div v-if="this.statusData.length > 0">
        <div v-if="todoTab" class="my-4">
          <span v-if="this.todo.length === 0">Nothing to show</span>
          <ul class="statusList">
            <li v-for="(task, index4) in this.todo" :key="index4">
              <a
                class="cursor-pointer"
                @click="openModalSectionLive(task, 'details')"
                >{{ task.name }}</a
              >
            </li>
          </ul>
        </div>
        <div v-if="progressTab" class="my-4">
          <span v-if="this.inProgress.length === 0">Nothing to show</span>
          <ul class="statusList">
            <li v-for="(task, index4) in this.inProgress" :key="index4">
              <a
                class="cursor-pointer"
                @click="openModalSectionLive(task, 'details')"
                >{{ task.name }}</a
              >
            </li>
          </ul>
        </div>
      </div>
      <vs-row
        v-if="this.statusData.length > 0"
        vs-type="flex"
        vs-justify="flex-end"
        class="mt-4"
      >
        <vs-button
          @click="warningPopupShow2 = false"
          type="filled"
          class="mr-2 vs-con-loading__container"
          >Manually Close</vs-button
        >
        <vs-button @click="completeProject" type="border"
          >Force Close</vs-button
        >
      </vs-row>
      <vs-row v-else vs-type="flex" vs-justify="flex-end" class="mt-4">
        <vs-button
          v-if="projectDetails.platform_project_completion_status.id === 1"
          @click="completeProject"
          type="border"
          >Complete Project</vs-button
        >
        <h5 class="task-cstm-badge" v-else>Project Completed</h5>
      </vs-row>

      <vs-popup title="Details" :active.sync="openUpdateModalDetails">
        <form class="flex flex-wrap">
          <div class="w-full">
            <div class="name-badge-holder">
              <span class="task-cstm-badge primary-badge">
                {{ taskData.projectStatusTag }}
              </span>
            </div>
          </div>
          <vs-row>
            <vs-col vs-lg="12" vs-sm="12" vs-xs="12" class="px-2 mb-2">
              <h5 class="mb-2">Status</h5>

              <select
                v-model="taskData.task_status_id"
                @change="StatusChnage(taskData)"
                name="cars"
                id="cars"
                form="carform"
                class="w-100 selectExample mt-2 customSelect"
              >
                <option
                  :key="index"
                  :value="item.id"
                  :label="item.status"
                  v-for="(item, index) in options"
                  class="selectOptionclass"
                />
              </select>
            </vs-col>
            <vs-divider />
            <vs-col vs-lg="6" vs-sm="6" vs-xs="12" class="px-2 mb-2">
              <h5 class="mb-2">Task Name:</h5>
              <p>{{ taskData.name }}</p>
            </vs-col>
            <vs-col vs-lg="12" vs-sm="12" vs-xs="12" class="px-2 mb-2">
              <h5 class="mb-2">Description</h5>
              <p>{{ taskData.details }}</p>
            </vs-col>

            <vs-col vs-lg="6" vs-sm="6" vs-xs="12" class="px-2 mb-2">
              <h5 class="mb-2">Responsible Person</h5>
              <span
                class="my-1 inline-block"
                :key="index4"
                v-for="(person, index4) in responsibleData"
              >
                <div class="flex items-center">
                  <img
                    v-if="person.picture != ''"
                    class="
                      person-img
                      rounded-full
                      shadow-md
                      cursor-pointer
                      block
                    "
                    :src="person.picture"
                  />
                  <img
                    v-if="person.picture == ''"
                    class="
                      person-img
                      rounded-full
                      shadow-md
                      cursor-pointer
                      block
                    "
                    src="@/assets/images/pages/user-circle-solid.svg"
                  />
                  {{ person.first_name }} {{ person.last_name }}
                  <span
                    v-if="index4 + 1 < responsibleData.length"
                    class="inline-block mr-1"
                    >,</span
                  >
                </div>
              </span>
            </vs-col>

            <vs-col vs-lg="6" vs-sm="6" vs-xs="12" class="px-2 mb-2">
              <h5 class="mb-2">Due Date</h5>
              <!-- <p class="ml-2">{{taskData.due_date}}</p> -->
              <p class="ml-2">
                <flat-pickr
                  class="dateformatChng"
                  v-model="taskData.due_date"
                  :config="configdateTimePicker1"
                  disabled
                />
              </p>
            </vs-col>
            <vs-tabs class="inner-tab" v-model="selectedTab">
              <vs-tab label="" icon-pack="feather" icon="icon-users">
                <div class="my-2">
                  <div class="flex items-center">
                    <feather-icon icon="UserIcon" />
                    <span class="mx-1">Created By</span>
                  </div>
                  <div class="flex flex-wrap -mx-2">
                    <div class="w-full px-2">
                      <strong class="block my-2">{{
                        userInfo.first_name
                      }}</strong>
                    </div>
                  </div>
                </div>

                <div class="my-2">
                  <div class="flex items-center">
                    <feather-icon icon="UserIcon" />
                    <span class="mx-1">Participants</span>
                  </div>
                  <div class="flex flex-wrap -mx-2">
                    <div class="cstm-inp flex-wrap">
                      <span
                        class="task-cstm-badge flex items-center"
                        :key="index4"
                        v-for="(person, index4) in participantData"
                      >
                        <img
                          v-if="person.picture != ''"
                          class="
                            person-img
                            rounded-full
                            shadow-md
                            cursor-pointer
                            block
                          "
                          :src="person.picture"
                        />
                        <img
                          v-if="person.picture == ''"
                          class="
                            person-img
                            rounded-full
                            shadow-md
                            cursor-pointer
                            block
                          "
                          src="@/assets/images/pages/user-circle-solid.svg"
                        />
                        {{ person.first_name }} {{ person.last_name }}
                        <span v-if="index4 + 1 < participantData.length"
                          >,</span
                        >
                      </span>
                    </div>
                  </div>
                </div>

                <div class="my-2">
                  <div class="flex items-center">
                    <feather-icon icon="UserIcon" />
                    <span class="mx-1">Observers</span>
                  </div>
                  <div class="flex flex-wrap -mx-2">
                    <div class="cstm-inp flex-wrap">
                      <span
                        class="task-cstm-badge flex items-center"
                        :key="index4"
                        v-for="(person, index4) in observerData"
                      >
                        <img
                          v-if="person.picture != ''"
                          class="
                            person-img
                            rounded-full
                            shadow-md
                            cursor-pointer
                            block
                          "
                          :src="person.picture"
                        />
                        <img
                          v-if="person.picture == ''"
                          class="
                            person-img
                            rounded-full
                            shadow-md
                            cursor-pointer
                            block
                          "
                          src="@/assets/images/pages/user-circle-solid.svg"
                        />
                        {{ person.first_name }} {{ person.last_name }}
                        <span v-if="index4 + 1 < observerData.length">,</span>
                      </span>
                    </div>
                  </div>
                </div>
              </vs-tab>
              <vs-tab label="" icon-pack="feather" icon="icon-clock">
                <div>
                  <div class="flex items-center my-2">
                    <feather-icon icon="ClockIcon" />
                    <span class="mx-1">Time Planning</span>
                  </div>
                  <!-- <label>From:</label>&nbsp;&nbsp;{{taskData.from_time}}<br>
                                                  <label>To:</label>&nbsp;&nbsp;{{taskData.to_time}} -->
                  <label>From:</label>&nbsp;&nbsp;<flat-pickr
                    class="dateformatChng"
                    v-model="taskData.from_time"
                    :config="configdateTimePicker1"
                    disabled
                  /><br />
                  <label>To:</label>&nbsp;&nbsp;<flat-pickr
                    class="dateformatChng"
                    v-model="taskData.to_time"
                    :config="configdateTimePicker1"
                    disabled
                  />
                  <vs-divider />
                  <div>
                    <div class="flex items-center my-2">
                      <feather-icon icon="ClockIcon" />
                      <span class="mx-1">Log History</span>
                    </div>
                    <div
                      class="task-cstm-badge flex items-center"
                      :key="index10"
                      v-for="(log, index10) in logHistory"
                    >
                      {{ log.no_of_days }}
                      <span class="mx-2">Days</span>
                      {{ log.no_of_hours }}
                      <span class="mx-2">Hour</span>
                    </div>
                  </div>
                </div>
              </vs-tab>

              <vs-tab label="" icon-pack="feather" icon="icon-list">
                <span v-if="taskData.checklist.length !== 0">
                  <span
                    :key="index8"
                    v-for="(item1, index8) in taskData.checklist"
                  >
                    <div class="flex flex-wrap items-center">
                      <div class="flex items-center my-2 lg:w-1/5 w-full">
                        <span class="material-icons">assignment</span>
                        <span class="mx-2">{{ item1.name }}</span>
                      </div>
                      <vs-progress
                        class="lg:w-1/2 md:w-3/5"
                        :percent="
                          (item1.itemStatusCal.length / item1.todos.length) *
                          100
                        "
                        color="primary"
                      ></vs-progress>
                      <div class="progress-status">
                        Completed: {{ item1.itemStatusCal.length }} out of
                        {{ item1.todos.length }}
                      </div>
                    </div>
                    <ul class="task-checklist mb-4">
                      <li
                        class="flex justify-between"
                        :key="index9"
                        v-for="(item2, index9) in item1.todos"
                      >
                        {{ item2.todo }}
                      </li>
                    </ul>
                  </span>
                </span>
              </vs-tab>

              <vs-tab label="" icon-pack="feather" icon="icon-grid">
                <div>
                  <div class="flex flex-wrap items-center">
                    <label class="w-1/5">Project</label>
                    <div class="cstm-inp w-1/2">
                      <span v-if="showDataForProject">
                        {{ showDataForProject.name }}</span
                      >
                    </div>
                  </div>
                  <vs-divider />

                  <div class="flex flex-wrap items-center">
                    <label class="w-1/5">Remind about task</label>
                    <div
                      class="inline-flex items-center m-1"
                      :key="index"
                      v-for="(item, index) in reminderTime"
                    >
                      {{ item.reminder_time }}<br />
                    </div>
                  </div>
                  <vs-divider />

                  <div class="flex flex-wrap items-center">
                    <label class="w-1/5">CRM</label>
                    <span
                      class="task-cstm-badge flex items-center"
                      :key="index8"
                      v-for="(crm, index8) in selectedCRMData"
                    >
                      {{ crm.lead_name }}
                      <span v-if="index8 + 1 < selectedCRMData.length">,</span>
                    </span>
                  </div>
                  <vs-divider />

                  <div class="flex flex-wrap items-center">
                    <label class="w-1/5">SubTask</label>
                    <span
                      class="task-cstm-badge flex items-center"
                      :key="index8"
                      v-for="(task, index8) in selectedSubTaskData"
                    >
                      {{ task.name }}
                      <span v-if="index8 + 1 < selectedSubTaskData.length"
                        >,</span
                      >
                    </span>
                  </div>
                  <vs-divider />

                  <div class="flex flex-wrap items-center">
                    <label class="w-1/5">Tags</label>
                    <span
                      class="task-cstm-badge flex items-center"
                      :key="index10"
                      v-for="(tag, index10) in tagName"
                    >
                      {{ tag.name }}
                      <span v-if="index10 + 1 < tagName.length">,</span>
                    </span>
                  </div>
                  <vs-divider />
                </div>
              </vs-tab>
              <vs-tab label="" icon-pack="feather" icon="icon-type">
                <div class="flex items-center">
                  <p v-html="taskData.comments"></p>
                </div>
              </vs-tab>
            </vs-tabs>
            <vs-divider />
          </vs-row>
        </form>
      </vs-popup>
    </vs-popup>
    <div
      class="vs-component con-vs-popup vs-popup-primary cstm-modal-popup"
      v-show="openUpdateModal"
      :class="{ show: openUpdateModal }"
    >
      <div class="cstm-modal" :class="[modelType == 'View' ? 'viewModal' : '']">
        <div class="header">
          <h3>{{ modelType }} Task</h3>
          <button @click="closeUpdateModal" class="close-modal">&times;</button>
        </div>
        <div class="each-tabular p-4">
          <div class="cstm-unique-tab-text modal-content">
            <div class="px-2">
              <div class="flex flex-wrap -mx-2">
                <div class="md:w-1/2 w-full px-2 my-2">
                  <vs-input
                    class="w-full"
                    v-model="taskData.name"
                    placeholder="Task Name"
                  />
                </div>
                <div class="md:w-1/2 w-full px-2 my-2">
                  <v-select
                    v-model="taskData.task_priority_id"
                    :reduce="(option) => option.id"
                    label="level"
                    name="level"
                    :options="priority"
                    placeholder="Choose Priority"
                    style="width: 100%"
                  />
                </div>
                <div
                  class="w-full px-2 my-2"
                  v-if="taskData.is_template !== true"
                >
                  <v-select
                    v-model="taskData.task_status_id"
                    :reduce="(option) => option.id"
                    label="status"
                    name="status"
                    :options="options"
                    placeholder="Choose Status"
                    style="width: 100%"
                  />
                </div>
                <div class="w-full px-2 my-2">
                  <vs-textarea
                    class="mb-0"
                    v-model="taskData.details"
                    label="Details"
                  />
                </div>
                <div class="md:w-1/2 w-full px-2 my-2">
                  <div class="person-holder">
                    <div>
                      <feather-icon icon="UserIcon" />
                      <span>Responsible Person</span>
                    </div>
                    <div class="cstm-inp flex-wrap">
                      <span
                        class="task-cstm-badge flex items-center mb-2"
                        :key="index4"
                        v-for="(person, index4) in responsibleData"
                      >
                        <img
                          v-if="person.picture != ''"
                          class="
                            person-img
                            rounded-full
                            shadow-md
                            cursor-pointer
                            block
                          "
                          :src="person.picture"
                        />
                        <img
                          v-if="person.picture == ''"
                          class="
                            person-img
                            rounded-full
                            shadow-md
                            cursor-pointer
                            block
                          "
                          src="@/assets/images/pages/user-circle-solid.svg"
                        />
                        {{ person.first_name }} {{ person.last_name }}
                        <feather-icon
                          class="cursor-pointer cross_close"
                          icon="XIcon"
                          @click="closeSelected('Responsible', index4)"
                        />
                      </span>
                      <a
                        v-if="responsibleData.length == 0"
                        class="font-bold cursor-pointer add_more_holder"
                        @click="addMoreUser('Responsible')"
                        >+ Add More</a
                      >
                    </div>
                  </div>
                </div>
                <div class="md:w-1/2 w-full px-2 my-2">
                  <span>Deadline</span>
                  <flat-pickr
                    class="cstm-datepicker w-full"
                    placeholder="Select Date"
                    v-model="taskData.due_date"
                    :config="configdateTimePicker1"
                    @input="updateCalendar"
                  />
                </div>
                <vs-divider />
                <vs-tabs class="inner-tab tooltip_icon_tab">
                  <vs-tab
                    label="Checklist"
                    icon-pack="feather"
                    icon="icon-list"
                  >
                    <span
                      :key="RenderKey"
                      v-if="taskData.checklist.length !== 0"
                    >
                      <span
                        :key="index8"
                        v-for="(item1, index8) in taskData.checklist"
                      >
                        <div class="md:flex flex-nowrap items-center">
                          <div class="flex items-center my-2 whitespace-nowrap">
                            <span class="material-icons">assignment</span>
                            <vs-input
                              style="width: 110px"
                              v-model="item1.name"
                              placeholder="Checklist Name"
                            />
                          </div>
                          <vs-progress
                            :percent="
                              (item1.itemStatusCal.length /
                                item1.todos.length) *
                              100
                            "
                            color="primary"
                          ></vs-progress>
                          <div
                            class="
                              progress-status
                              w-auto
                              text-left
                              md:text-right
                              whitespace-nowrap
                              p-0
                              md:pl-2
                            "
                          >
                            Completed: {{ item1.itemStatusCal.length }} out of
                            {{ item1.todos.length }}
                          </div>
                        </div>
                        <ul class="checklist-ul task-checklist mb-4 m-0">
                          <draggable
                            :list="item1.todos"
                            @change="statusLog"
                            class="w-full p-2"
                            handle=".handle1"
                          >
                            <li
                              class="flex justify-between"
                              :key="index9"
                              v-for="(item2, index9) in item1.todos"
                            >
                              <div class="flex items-center">
                                <span
                                  class="
                                    material-icons-outlined
                                    simple_drag_icon
                                    handle1
                                  "
                                  >drag_indicator</span
                                >
                                <vs-checkbox
                                  v-model="item2.is_completed"
                                  @change="changeStatus(index8, index9)"
                                ></vs-checkbox>
                                <span v-html="replaceURLs(item2.todo)"></span>
                              </div>
                              <div class="flex">
                                <vs-button
                                  color="warning"
                                  @click="editItem(index8, index9, item2)"
                                  icon-pack="feather"
                                  icon="icon-edit"
                                  type="flat"
                                ></vs-button>
                                <vs-button
                                  color="danger"
                                  @click="deleteItem(index8, index9)"
                                  icon-pack="feather"
                                  icon="icon-trash-2"
                                  type="flat"
                                ></vs-button>
                              </div>
                            </li>
                          </draggable>
                          <div
                            class="flex justify-between"
                            :key="index2"
                            v-for="(testBox, index2) in item1.showTextBox"
                          >
                            <vs-input
                              class="inputx w-full mb-4"
                              placeholder="Type and enter to create item"
                              @keyup.native.enter="
                                submitItemNewTask(index8, item1)
                              "
                              v-model="testBox.itemName"
                            />
                            <vs-button
                              color="danger"
                              icon-pack="feather"
                              icon="icon-trash-2"
                              type="flat"
                              @click="removeItemNewTask(index8, index2)"
                            ></vs-button>
                          </div>
                          <a
                            style="
                              padding-bottom: 2px;
                              border-bottom: 1px solid
                                rgba(var(--vs-primary), 1);
                            "
                            class="cursor-pointer"
                            @click="addItemNewTask(index8)"
                            >+ Item</a
                          >
                        </ul>
                      </span>
                    </span>
                    <div
                      :key="index3"
                      v-for="(checklistRow, index3) in checklistRows"
                    >
                      <div class="md:flex flex-nowrap items-center">
                        <div class="flex items-center my-2 whitespace-nowrap">
                          <span class="material-icons">assignment</span>
                          <vs-input
                            style="width: 110px"
                            v-model="checklistRow.name"
                            placeholder="Checklist Name"
                          />
                        </div>
                        <vs-progress
                          :percent="
                            (checklistRow.itemStatusCal.length /
                              checklistRow.items.length) *
                            100
                          "
                          color="primary"
                        ></vs-progress>
                        <div
                          class="
                            progress-status
                            w-auto
                            text-left
                            md:text-right
                            whitespace-nowrap
                            p-0
                            md:pl-2
                          "
                        >
                          Completed: {{ checklistRow.itemStatusCal.length }} out
                          of {{ checklistRow.items.length }}
                        </div>
                      </div>
                      <ul class="checklist-ul task-checklist mb-4 m-0">
                        <draggable
                          :list="checklistRow.items"
                          @change="statusLog"
                          class="w-full p-2"
                          handle=".handle2"
                        >
                          <li
                            class="flex justify-between"
                            :key="index6"
                            v-for="(item, index6) in checklistRow.items"
                          >
                            <div class="flex items-center">
                              <span
                                class="
                                  material-icons-outlined
                                  simple_drag_icon
                                  handle2
                                "
                                >drag_indicator</span
                              >
                              <vs-checkbox
                                v-model="item.is_completed"
                                @change="changeStatusFromCheck(index3, index6)"
                              ></vs-checkbox>
                              <span v-html="replaceURLs(item.todo)"></span>
                            </div>
                            <div class="flex">
                              <vs-button
                                color="warning"
                                @click="editItemFromCheck(index3, index6, item)"
                                icon-pack="feather"
                                icon="icon-edit"
                                type="flat"
                              ></vs-button>
                              <vs-button
                                color="danger"
                                @click="deleteItemFromCheck(index3, index6)"
                                icon-pack="feather"
                                icon="icon-trash-2"
                                type="flat"
                              ></vs-button>
                            </div>
                          </li>
                        </draggable>
                      </ul>
                      <div
                        class="flex justify-between"
                        :key="index2"
                        v-for="(testBox, index2) in checklistRow.showTextBox"
                      >
                        <vs-input
                          class="inputx w-full mb-4"
                          placeholder="Type and enter to create item"
                          @keyup.native.enter="submitItem(index3, checklistRow)"
                          v-model="testBox.itemName"
                        />
                        <vs-button
                          class="cross_close"
                          color="danger"
                          icon-pack="feather"
                          icon="icon-trash-2"
                          type="flat"
                          @click="removeItem(checklistRow, index2)"
                        ></vs-button>
                      </div>
                      <div class="flex flex-wrap justify-between items-center">
                        <a
                          style="
                            padding-bottom: 2px;
                            border-bottom: 1px solid rgba(var(--vs-primary), 1);
                          "
                          class="cursor-pointer add_more_holder"
                          @click="addItem(checklistRow)"
                          >+ Item</a
                        >
                        <a
                          style="color: #ea5455"
                          class="cursor-pointer cross_close"
                          color="danger"
                          @click="removeChecklist(index3)"
                          type="flat"
                          >Remove All</a
                        >
                      </div>
                      <vs-divider />
                    </div>

                    <vs-button
                      class="my-4 add_more_holder"
                      @click="addChecklist"
                      >+ Checklist</vs-button
                    >
                  </vs-tab>
                  <vs-tab
                    label="Created By"
                    icon-pack="feather"
                    icon="icon-users"
                  >
                    <div class="my-2">
                      <div class="flex items-center">
                        <feather-icon icon="UserIcon" />
                        <span class="mx-1">Created By</span>
                      </div>
                      <div class="flex flex-wrap -mx-2">
                        <div class="w-full px-2">
                          <vs-input
                            v-if="taskData.created_by.last_name === null"
                            class="w-full"
                            :value="taskData.created_by.first_name"
                            readonly
                          />
                          <vs-input
                            v-else
                            class="w-full"
                            :value="
                              taskData.created_by.first_name +
                              ' ' +
                              taskData.created_by.last_name
                            "
                            readonly
                          />
                        </div>
                      </div>
                    </div>

                    <div class="my-2">
                      <div class="flex items-center">
                        <feather-icon icon="UserIcon" />
                        <span class="mx-1">Participants</span>
                      </div>
                      <div class="flex flex-wrap -mx-2">
                        <div class="cstm-inp flex-wrap">
                          <span
                            class="task-cstm-badge flex items-center"
                            :key="index4"
                            v-for="(person, index4) in participantData"
                          >
                            <img
                              v-if="person.picture != ''"
                              class="
                                person-img
                                rounded-full
                                shadow-md
                                cursor-pointer
                                block
                              "
                              :src="person.picture"
                            />
                            <img
                              v-if="person.picture == ''"
                              class="
                                person-img
                                rounded-full
                                shadow-md
                                cursor-pointer
                                block
                              "
                              src="@/assets/images/pages/user-circle-solid.svg"
                            />
                            {{ person.first_name }} {{ person.last_name }}
                            <feather-icon
                              class="cursor-pointer cross_close"
                              icon="XIcon"
                              @click="closeSelected('Participants', index4)"
                            />
                          </span>
                          <a
                            class="font-bold cursor-pointer add_more_holder"
                            @click="addMoreUser('Participants')"
                            >+ Add More</a
                          >
                        </div>
                      </div>
                    </div>

                    <div class="my-2">
                      <div class="flex items-center">
                        <feather-icon icon="UserIcon" />
                        <span class="mx-1">Observers</span>
                      </div>
                      <div class="flex flex-wrap -mx-2">
                        <div class="cstm-inp flex-wrap">
                          <span
                            class="task-cstm-badge flex items-center"
                            :key="index4"
                            v-for="(person, index4) in observerData"
                          >
                            <img
                              v-if="person.picture != ''"
                              class="
                                person-img
                                rounded-full
                                shadow-md
                                cursor-pointer
                                block
                              "
                              :src="person.picture"
                            />
                            <img
                              v-if="person.picture == ''"
                              class="
                                person-img
                                rounded-full
                                shadow-md
                                cursor-pointer
                                block
                              "
                              src="@/assets/images/pages/user-circle-solid.svg"
                            />
                            {{ person.first_name }} {{ person.last_name }}
                            <feather-icon
                              class="cursor-pointer cross_close"
                              icon="XIcon"
                              @click="closeSelected('Observers', index4)"
                            />
                          </span>
                          <a
                            class="font-bold cursor-pointer add_more_holder"
                            @click="addMoreUser('Observers')"
                            >+ Add More</a
                          >
                        </div>
                      </div>
                    </div>
                  </vs-tab>

                  <vs-tab
                    label="Time Planning"
                    icon-pack="feather"
                    icon="icon-clock"
                  >
                    <div>
                      <div class="flex items-center my-2">
                        <feather-icon icon="ClockIcon" />
                        <span class="mx-1">Time Planning</span>
                      </div>
                      <div class="flex flex-wrap items-center">
                        <div class="md:w-1/2 w-full md:pr-2">
                          <label class="w-full">From</label>
                          <div class="fake_flatpickr_holder">
                            <div class="fake_input_holder">
                              <span v-if="taskData.from_time !== ''">{{
                                $moment(taskData.from_time).format(
                                  "D MMMM, YYYY h:mm A"
                                )
                              }}</span>
                              <span v-else>-</span>
                            </div>
                            <flat-pickr
                              :config="configdateTimePicker"
                              v-model="taskData.from_time"
                              @on-close="checkWhenClose('from')"
                            />
                          </div>
                        </div>
                        <div class="md:w-1/2 w-full md:pl-2">
                          <label class="w-full">To</label>
                          <div class="fake_flatpickr_holder">
                            <div class="fake_input_holder">
                              <span v-if="taskData.to_time !== ''">{{
                                $moment(taskData.to_time).format(
                                  "D MMMM, YYYY h:mm A"
                                )
                              }}</span>
                              <span v-else>-</span>
                            </div>
                            <flat-pickr
                              :config="configdateTimePicker"
                              v-model="taskData.to_time"
                              @on-close="checkWhenClose('to')"
                              :disabled="taskData.from_time == ''"
                            />
                          </div>
                        </div>
                      </div>
                      <vs-divider />
                      <div v-if="taskData.is_tracking_active">
                        <div
                          v-if="
                            participantData.find((u) => u.id == userInfo.id)
                          "
                        >
                          <div class="flex items-center my-2">
                            <feather-icon icon="ClockIcon" />
                            <span class="mx-1">Log</span>
                          </div>
                          <div
                            class="flex flex-wrap items-center"
                            :key="index10"
                            v-for="(log, index10) in logs"
                          >
                            <vs-input
                              class="width-10"
                              v-model="log.no_of_days"
                              type="number"
                            />
                            <span class="mx-2">Days</span>
                            <vs-input
                              class="width-10"
                              v-model="log.no_of_hours"
                              type="number"
                            />
                            <span class="mx-2">Hour</span>
                          </div>
                          <br />
                          <vs-button @click="addLog">+ Log</vs-button>&nbsp;
                          <vs-button
                            color="success"
                            @click="submitLog(live_update_id)"
                            >Save</vs-button
                          >

                          <div>
                            <div class="flex items-center my-2">
                              <feather-icon icon="ClockIcon" />
                              <span class="mx-1">Log History</span>
                            </div>
                            <div
                              class="task-cstm-badge flex items-center"
                              :key="index10"
                              v-for="(log, index10) in logHistory"
                            >
                              {{ log.no_of_days }}
                              <span class="mx-2">Days</span>
                              {{ log.no_of_hours }}
                              <span class="mx-2">Hour</span>
                            </div>
                            <br />
                          </div>
                        </div>
                      </div>
                    </div>
                  </vs-tab>

                  <vs-tab label="Project" icon-pack="feather" icon="icon-grid">
                    <div>
                      <div class="flex flex-wrap items-center">
                        <label class="md:w-1/5 w-full">Projects</label>
                        <div class="md:w-3/4 w-full">
                          <v-select
                            v-model="taskData.project"
                            class="w-full"
                            :reduce="(option) => option.id"
                            label="name"
                            name="name"
                            :options="projectList"
                            placeholder="Project"
                            @open="onOpenProject"
                            @close="onCloseProject"
                          >
                            <template #list-footer>
                              <li
                                ref="loadProject"
                                class="loader"
                                v-show="projectListMeta.has_next"
                              >
                                Loading more project...
                              </li>
                            </template>
                          </v-select>
                        </div>
                      </div>
                      <vs-divider />

                      <div class="flex flex-wrap items-center">
                        <div class="md:w-1/5 w-full">
                          <label>Remind about task</label>
                        </div>
                        <!-- class reminder_holder removed  -->
                        <div class="md:w-3/4 w-full">
                          <div
                            class="inline-flex items-center m-1 w-full"
                            :key="index"
                            v-for="(item, index) in reminderTime"
                          >
                            <flat-pickr
                              class="w-full"
                              :config="configdateTimePicker1"
                              v-model="item.reminder_time"
                              placeholder="Choose Date & Time"
                            />
                            <vs-button
                              class="cursor-pointer font-semibold ml-1"
                              @click="removeReminder(index)"
                              icon-pack="feather"
                              icon="icon-minus"
                              color="danger"
                            ></vs-button>
                          </div>
                          <a
                            class="
                              cursor-pointer
                              font-semibold
                              block
                              add_more_holder
                            "
                            @click="addReminder"
                            >+ Reminder</a
                          >
                        </div>
                      </div>
                      <vs-divider />
                      <div class="flex flex-wrap items-center">
                        <label class="md:w-1/5 w-full">CRM</label>
                        <div class="cstm-inp md:w-3/4 w-full">
                          <span
                            class="task-cstm-badge flex items-center"
                            :key="index8"
                            v-for="(crm, index8) in selectedCRMData"
                          >
                            {{ crm.lead_first_name }}
                            <feather-icon
                              class="cursor-pointer"
                              icon="XIcon"
                              @click="closeSelected('CRM', index8)"
                            />
                          </span>
                          <a
                            class="font-bold cursor-pointer add_more_holder"
                            @click="addModal('CRM')"
                            >+ Add More</a
                          >
                        </div>
                      </div>
                      <vs-divider />

                      <div class="flex flex-wrap items-center">
                        <label class="md:w-1/5 w-full">SubTask</label>
                        <div class="cstm-inp md:w-3/4 w-full">
                          <span
                            class="task-cstm-badge flex items-center"
                            :key="index8"
                            v-for="(task, index8) in selectedSubTaskData"
                          >
                            {{ task.name }}
                            <feather-icon
                              class="cursor-pointer"
                              icon="XIcon"
                              @click="closeSelected('subTask', index8)"
                            />
                          </span>
                          <a
                            class="font-bold cursor-pointer add_more_holder"
                            @click="addModal('subTask')"
                            >+ Add</a
                          >
                        </div>
                      </div>
                      <vs-divider />

                      <div class="flex flex-wrap items-center">
                        <label class="md:w-1/5 w-full">Tags</label>
                        <div style="margin: 0 5px" class="md:w-3/4 w-full">
                          <v-select
                            append-to-body
                            class="w-full"
                            label="name"
                            taggable
                            :reduce="(option) => option.id"
                            :create-option="
                              (option) => ({
                                id: option,
                                label: option,
                                name: option,
                              })
                            "
                            :options="tagsList"
                            v-model="taskData.tags"
                            :clearable="false"
                            data-vv-name="name"
                            name="name"
                            multiple
                            placeholder="Type and Enter"
                          >
                          </v-select>
                        </div>
                      </div>
                    </div>
                  </vs-tab>
                  <vs-tab
                    class="editor_tab"
                    label="Editor"
                    icon-pack="feather"
                    icon="icon-type"
                  >
                    <editor
                      :api-key="tinyMceApi"
                      v-model="taskData.comments"
                      :init="initializeTinyMce"
                    />
                  </vs-tab>
                </vs-tabs>
                <vs-divider />
                <div class="md:w-1/2 w-full px-2 my-2 save_tmp">
                  <vs-checkbox v-model="taskData.is_template" vs-value="1"
                    >Save this as a template</vs-checkbox
                  >
                </div>
              </div>
            </div>
            <div class="my-2 text-right">
              <vs-button
                class="mx-2 update_btn_holder"
                :disabled="!buttonActive"
                @click="updateTaskDataLiveFromProject"
                >Update</vs-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <vs-popup
      classContent="popup-example"
      class="editChecklistPopup"
      title="Edit Item"
      :active.sync="checklistEditPopup"
    >
      <vs-input
        placeholder="Type and enter to create item"
        v-model="editChecklistName"
        @keyup.native.enter="updateItemForCheck()"
        class="mt-5 w-full"
      />
    </vs-popup>
    <vs-popup
      classContent="popup-example"
      class="editChecklistPopup"
      title="Edit Item"
      :active.sync="checklistEditPopup2"
    >
      <vs-input
        placeholder="Type and enter to create item"
        v-model="editChecklistName"
        @keyup.native.enter="updateItem()"
        class="mt-5 w-full"
      />
    </vs-popup>
    <vs-popup
      class="holamundo userModalStyle"
      :title="typeOfPersonTitle"
      :active.sync="popupresponse"
    >
      <vs-tabs class="cstm_line_tabular_view">
        <vs-tab label="Staff">
          <div class="tab-text">
            <vs-input
              v-if="currentPageUser == 1"
              class="ml-auto mb-4"
              icon-pack="feather"
              icon="icon-search"
              icon-before
              placeholder="Search"
              type="text"
              @input="fetchUserBySearch"
              v-model="searchName"
              >Search</vs-input
            >
            <div class="person-list-holder">
              <vs-table v-model="selectedUsers" :data="userList">
                <!-- <template slot="thead">
                  <vs-th colspan="2">Select All</vs-th>
                </template> -->

                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :data="data[indextr].picture">
                      <img
                        v-if="data[indextr].picture != ''"
                        class="
                          person-img
                          rounded-full
                          shadow-md
                          cursor-pointer
                          block
                        "
                        :src="data[indextr].picture"
                      />
                      <img
                        v-if="data[indextr].picture == ''"
                        class="
                          person-img
                          rounded-full
                          shadow-md
                          cursor-pointer
                          block
                        "
                        src="@/assets/images/pages/user-circle-solid.svg"
                      />
                    </vs-td>

                    <vs-td :data="data[indextr].first_name">
                      {{ data[indextr].first_name }}
                      {{ data[indextr].last_name }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>

             <!--  <div class="flex flex-wrap justify-between items-center my-4">
                <div>
                  <vs-button
                    v-if="currentPageUser > 1"
                    @click="showBackUser"
                    icon-pack="feather"
                    icon="icon-chevron-left"
                  ></vs-button>
                </div>
                <div class="text-right">
                  <vs-button
                    icon-pack="feather"
                    icon="icon-chevron-right"
                    v-if="showButtonUser == true"
                    @click="showMoreUser"
                  >
                  </vs-button>
                </div>
              </div> -->
            </div>
          </div>
        </vs-tab>
        <vs-tab label="Student">
          <div class="tab-text">
            <vs-input
              v-if="currentPageClient == 1"
              class="ml-auto mb-4"
              icon-pack="feather"
              icon="icon-search"
              icon-before
              placeholder="Search"
              type="text"
              @input="fetchClientBySearch"
              v-model="searchName"
              >Search</vs-input
            >
            <div class="person-list-holder">
              <vs-table v-model="selectedClients" :data="clientList">
                <!-- <template slot="thead">
                  <vs-th colspan="2">Select All</vs-th>
                </template> -->
                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :data="data[indextr].picture">
                      <img
                        v-if="data[indextr].picture != ''"
                        class="
                          person-img
                          rounded-full
                          shadow-md
                          cursor-pointer
                          block
                        "
                        :src="data[indextr].picture"
                      />
                      <img
                        v-if="data[indextr].picture == ''"
                        class="
                          person-img
                          rounded-full
                          shadow-md
                          cursor-pointer
                          block
                        "
                        src="@/assets/images/pages/user-circle-solid.svg"
                      />
                    </vs-td>
                    <vs-td :data="data[indextr].first_name">
                      {{ data[indextr].first_name }}
                      {{ data[indextr].last_name }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
<!--               <div class="flex flex-wrap justify-between items-center my-4">
                <div>
                  <vs-button
                    v-if="currentPageClient > 1"
                    @click="showBackClient"
                    icon-pack="feather"
                    icon="icon-chevron-left"
                  ></vs-button>
                </div>
                <div class="text-right">
                  <vs-button
                    icon-pack="feather"
                    icon="icon-chevron-right"
                    v-if="showButtonClient == true"
                    @click="showMoreClient"
                  ></vs-button>
                </div>
              </div> -->
            </div>
          </div>
        </vs-tab>
      </vs-tabs>
      <vs-button class="float-right" @click="addUser">Add</vs-button>
    </vs-popup>
    <vs-popup
      class="holamundo userModalStyle"
      :title="typeOfPersonTitle"
      :active.sync="popupActive"
    >
      <vs-tabs class="cstm_line_tabular_view">
        <vs-tab label="Staff">
          <div class="tab-text">
            <vs-input
              v-if="currentPageUser == 1"
              class="ml-auto mb-4"
              icon-pack="feather"
              icon="icon-search"
              icon-before
              placeholder="Search"
              type="text"
              @input="fetchUserBySearch"
              v-model="searchName"
              >Search</vs-input
            >
            <div class="person-list-holder">
              <vs-table multiple v-model="selectedUsers" :data="userList">
                <template slot="thead">
                  <vs-th colspan="2">Select All</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :data="data[indextr].picture">
                      <img
                        v-if="data[indextr].picture != ''"
                        class="
                          person-img
                          rounded-full
                          shadow-md
                          cursor-pointer
                          block
                        "
                        :src="data[indextr].picture"
                      />
                      <img
                        v-if="data[indextr].picture == ''"
                        class="
                          person-img
                          rounded-full
                          shadow-md
                          cursor-pointer
                          block
                        "
                        src="@/assets/images/pages/user-circle-solid.svg"
                      />
                    </vs-td>

                    <vs-td :data="data[indextr].first_name">
                      {{ data[indextr].first_name }}
                      {{ data[indextr].last_name }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>

              <!-- <div class="flex flex-wrap justify-between items-center my-4">
                <div>
                  <vs-button
                    v-if="currentPageUser > 1"
                    @click="showBackUser"
                    icon-pack="feather"
                    icon="icon-chevron-left"
                  ></vs-button>
                </div>
                <div class="text-right">
                  <vs-button
                    icon-pack="feather"
                    icon="icon-chevron-right"
                    v-if="showButtonUser == true"
                    @click="showMoreUser"
                  >
                  </vs-button>
                </div>
              </div> -->
            </div>
          </div>
        </vs-tab>
        <vs-tab label="Student">
          <div class="tab-text">
            <vs-input
              v-if="currentPageClient == 1"
              class="ml-auto mb-4"
              icon-pack="feather"
              icon="icon-search"
              icon-before
              placeholder="Search"
              type="text"
              @input="fetchClientBySearch"
              v-model="searchName"
              >Search</vs-input
            >
            <div class="person-list-holder">
              <vs-table multiple v-model="selectedClients" :data="clientList">
                <template slot="thead">
                  <vs-th colspan="2">Select All</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :data="data[indextr].picture">
                      <img
                        v-if="data[indextr].picture != ''"
                        class="
                          person-img
                          rounded-full
                          shadow-md
                          cursor-pointer
                          block
                        "
                        :src="data[indextr].picture"
                      />
                      <img
                        v-if="data[indextr].picture == ''"
                        class="
                          person-img
                          rounded-full
                          shadow-md
                          cursor-pointer
                          block
                        "
                        src="@/assets/images/pages/user-circle-solid.svg"
                      />
                    </vs-td>
                    <vs-td :data="data[indextr].first_name">
                      {{ data[indextr].first_name }}
                      {{ data[indextr].last_name }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
           <!--    <div class="flex flex-wrap justify-between items-center my-4">
                <div>
                  <vs-button
                    v-if="currentPageClient > 1"
                    @click="showBackClient"
                    icon-pack="feather"
                    icon="icon-chevron-left"
                  ></vs-button>
                </div>
                <div class="text-right">
                  <vs-button
                    icon-pack="feather"
                    icon="icon-chevron-right"
                    v-if="showButtonClient == true"
                    @click="showMoreClient"
                  ></vs-button>
                </div>
              </div> -->
            </div>
          </div>
        </vs-tab>
      </vs-tabs>
      <vs-button class="float-right" @click="addUser">Add</vs-button>
    </vs-popup>
    <vs-popup
      class="holamundo userModalStyle"
      title="Add Project"
      :active.sync="popupActiveProj"
    >
      <vs-tabs>
        <vs-tab label="Project">
          <div class="tab-text">
            <div class="person-list-holder">
              <vs-table
                multiple
                v-model="selectedProjects"
                :data="ListOfProject"
              >
                <template slot="thead">
                  <vs-th colspan="2">Select All</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :data="data[indextr].name">
                      {{ data[indextr].name }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <vs-row vs-type="flex" vs-justify="space-between">
                <vs-col
                  vs-type="flex"
                  vs-justify="flex-end"
                  vs-align="flex-end"
                  vs-w="11.5"
                >
                  <vs-button
                    v-if="meta.has_next"
                    @click="showProj('plus')"
                    icon-pack="feather"
                    icon="icon-plus"
                    style="float: right"
                    >More</vs-button
                  >
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-justify="flex-end"
                  vs-align="flex-end"
                  vs-w=".5"
                >
                  <vs-button
                    type="flat"
                    v-if="meta.current_page > 1"
                    @click="showProj('minus')"
                    icon-pack="feather"
                    icon="icon-arrow-left"
                  ></vs-button>
                </vs-col>
              </vs-row>
            </div>
          </div>
        </vs-tab>
      </vs-tabs>
      <vs-button class="float-right" @click="addMicData('project')"
        >Add</vs-button
      >
    </vs-popup>
    <vs-popup
      class="holamundo userModalStyle"
      title="Add CRM"
      :active.sync="popupActiveCRM"
    >
      <vs-tabs>
        <vs-tab label="CRM">
          <div class="tab-text">
            <div class="person-list-holder">
              <vs-table multiple v-model="selectedCRM" :data="leadList">
                <template slot="thead">
                  <vs-th colspan="2">Select All</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :data="data[indextr].lead_first_name">
                      {{ data[indextr].lead_first_name }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <vs-row vs-type="flex" vs-justify="space-between">
                <vs-col
                  vs-type="flex"
                  vs-justify="flex-end"
                  vs-align="flex-end"
                  vs-w="11.5"
                >
                  <vs-button
                    v-if="leadMeta.has_next"
                    @click="showCRM('plus')"
                    icon-pack="feather"
                    icon="icon-plus"
                    style="float: right"
                    >More</vs-button
                  >
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-justify="flex-end"
                  vs-align="flex-end"
                  vs-w=".5"
                >
                  <vs-button
                    type="flat"
                    v-if="leadMeta.current_page > 1"
                    @click="showCRM('minus')"
                    icon-pack="feather"
                    icon="icon-arrow-left"
                  ></vs-button>
                </vs-col>
              </vs-row>
            </div>
          </div>
        </vs-tab>
      </vs-tabs>
      <vs-button class="float-right" @click="addMicData('CRM')">Add</vs-button>
    </vs-popup>
    <vs-popup
      class="holamundo userModalStyle"
      title="Add Sub Task"
      :active.sync="popupActiveSubTask"
    >
      <vs-tabs>
        <vs-tab label="Sub Task">
          <div class="tab-text">
            <div class="person-list-holder">
              <vs-table
                multiple
                v-model="selectedSubTask"
                :data="parentTaskData"
              >
                <template slot="thead">
                  <vs-th colspan="2">Select All</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :data="data[indextr].name">
                      {{ data[indextr].name }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <vs-row vs-type="flex" vs-justify="space-between">
                <vs-col
                  vs-type="flex"
                  vs-justify="flex-end"
                  vs-align="flex-end"
                  vs-w="11.5"
                >
                  <vs-button
                    v-if="sub_meta.has_next"
                    @click="showSubTask('plus')"
                    icon-pack="feather"
                    icon="icon-plus"
                    style="float: right"
                    >More</vs-button
                  >
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-justify="flex-end"
                  vs-align="flex-end"
                  vs-w=".5"
                >
                  <vs-button
                    type="flat"
                    v-if="sub_meta.current_page > 1"
                    @click="showSubTask('minus')"
                    icon-pack="feather"
                    icon="icon-arrow-left"
                  ></vs-button>
                </vs-col>
              </vs-row>
            </div>
          </div>
        </vs-tab>
      </vs-tabs>
      <vs-button class="float-right" @click="addMicData('subTask')"
        >Add</vs-button
      >
    </vs-popup>
    <div v-if="isBrowseContent">
      <vs-popup
        fullscreen
        title="Browse Item"
        :active.sync="isBrowseContent"
        class="childImportPopUp browse_modal_item"
      >
        <import-browse-files-model
          v-if="isBrowseContent"
          :file_repository_id="repository_id"
          @getImportFile="getImportFile"
          :multipleSelect="true"
        ></import-browse-files-model>
        <div slot="footer"></div>
      </vs-popup>
    </div>
    <vs-popup title="Warning" :active.sync="additionalPopUp">
      <h3>
        One or more tasks could not be deleted as they are referred somewhere
        else.
      </h3>
      <vs-list>
        <vs-list-item
          v-for="(item, index) in nonDeletableItems"
          :key="index"
          :title="item"
        ></vs-list-item>
      </vs-list>
    </vs-popup>
  </div>
</template>

<script>
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { Project } from './mixins/project.js'
import { TaskProject } from './mixins/task-project.js'
import draggable from 'vuedraggable'
import vSelect from 'vue-select'
import { mapGetters, mapActions } from 'vuex'
import {
  projectKanbanShow,
  taskUpdate,
  kanbanReorder,
  taskStatusCheck,
  projectUpdate,
  taskShow
} from '@/api/task-project.js'
import ExtraActionProject from './components/ExtraActionProject.vue'
import { GoogleAuthorization } from '@/mixins/common/GoogleAuthorization.js'
import ImportBrowseFilesModel from '@/components/common/ImportBrowseFilesModel.vue'

export default {
  name: 'project-details',
  mixins: [Project, TaskProject, PermissionMiddleware, GoogleAuthorization],
  components: {
    flatPickr,
    draggable,
    vSelect,
    ExtraActionProject,
    ImportBrowseFilesModel
  },
  data () {
    return {
      modelType: '',
      addedStatus: '',
      options: [
        { id: 1, status: 'To Do' },
        { id: 2, status: 'In Progress' },
        { id: 3, status: 'Done' }
      ],
      reorderStatus: false,
      addBoardPopup: false,
      warningPopupShow: false,
      warningPopupShow2: false,
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      projectDetails: {
        platform_project_completion_status: {
          id: ''
        },
        name: '',
        userProjectMember: [],
        clientProjectMember: [],
        due_date: '',
        details: ''
      },
      todo: [],
      inProgress: [],
      statusData: [],
      todoTab: true,
      progressTab: false
    }
  },
  computed: {
    ...mapGetters(['get_update_data']),
    buttonActive () {
      if (
        this.responsibleData.length !== 0 &&
        this.taskData.name !== '' &&
        this.taskData.task_priority_id !== ''
      ) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    liveTaskImportData () {
      const obj = {
        liveTaskImportData: this.liveTaskImportData,
        meta: this.meta
      }
      this.$store.commit('UPDATE_IMPORT_LIST', obj)
    },
    get_update_data () {
      if (this.get_update_data) {
        this.checkPermissionForStaff()
        this.getAllTask()
      }
    },
    popupActive: {
      deep: true,
      handler () {
        if (!this.popupActive) {
          this.searchName = ''
          this.fetchClient()
          this.fetchUser()
        }
      }
    },
    popupresponse: {
      deep: true,
      handler () {
        if (!this.popupresponse) {
          this.searchName = ''
          this.fetchClient()
          this.fetchUser()
        }
      }
    }
  },
  async mounted () {
    this.checkPermissionForStaff()
    this.getAllTask()
    this.fetchProject(this.meta)
    this.fetchLiveTask(this.query_page.page)
    this.fetchTask(this.query_page)
    this.file_repository_id = this.$store.getters.getRepoId
    this.userList = this.$store.getters.getGlobalUserList
    this.currentPageUser = this.$store.getters.getCurrentPageUser
    this.currentPageClient = this.$store.getters.getcurrentPageClient
    this.showButtonUser = this.$store.getters.getShowButtonUser
    this.clientList = this.$store.getters.getGlobalClientList
    this.showButtonClient = this.$store.getters.getShowButtonClient
    this.priority = this.$store.getters.getGlobalPriorityList
    this.tagsList = this.$store.getters.getGlobalTagList
    this.tag_meta = this.$store.getters.getTagMeta
    this.parentTaskData = this.$store.getters.getGlobalParentList
    this.sub_meta = this.$store.getters.getSubMeta
    this.ListOfTaskUpdate = this.$store.getters.getListOfTaskUpdate
    this.meta_template = this.$store.getters.getMetaTemplate
    this.ListOfLiveTaskUpdate = this.$store.getters.getListOfLiveTaskUpdate
    this.meta_task = this.$store.getters.getMetaTask
    this.ListOfProject = this.$store.getters.getListOfProject
    this.meta = this.$store.getters.getMeta
    this.leadList = this.$store.getters.getGlobalLeadList
    this.leadMeta = this.$store.getters.getLeadMeta
  },
  methods: {
    ...mapActions(['SET_UPDATE_DATA']),
    warningPopup () {
      this.warningPopupShow = true
    },
    backToProject () {
      this.$router.push({ name: 'tasks-project', params: { tab: 'projects' } })
    },
    closeUpdateModal () {
      this.clearData()
      this.openUpdateModal = false
    },
    checkPermissionForStaff () {
      const role_permission = parseInt(localStorage.getItem('role_permission'))
      if (role_permission === 1) {
        this.schoolAdmin = true
      } else {
        this.schoolAdmin = false
        this.getModulePermission('Tasks')
        this.getModulePermission('Projects')
      }
    },
    openModalSectionLiveFromProject (data, id, type) {
      if (this.checkProjectEditPermission()) {
        this.live_update_id = data.id
        this.projectStatusId = id
        this.modelType = type
        taskShow(localStorage.getItem('customer_id'), this.live_update_id)
          .then((res) => {
            const task = res.data.data.task
            this.responsibleData = task.userResponsiblePerson.concat(
              task.clientResponsiblePerson
            )
            this.observerData = task.userObserver.concat(task.clientObserver)
            this.participantData = task.userParticipant.concat(
              task.clientParticipant
            )
            this.projectStatusTagId = task.projectStatusTag
            this.tagName = task.tags
            this.taskData.name = task.name
            this.taskData.due_date = task.due_date
            this.changedDataForFlatpicker.dueDate = task.due_date
            this.taskData.task_priority_id = task.task_priority.id
            this.taskData.comments = task.comments
            this.taskData.created_by = task.created_by
            this.taskData.is_tracking_active = task.is_tracking_active
            this.taskData.details = task.details
            this.taskData.checklist = task.checklist
            this.taskData.task_status_id = task.status.id
            this.taskData.checklist.map((row, index) => {
              const itemStatusCal = this.taskData.checklist[index].todos.filter(
                (ele) => {
                  return ele.is_completed === true
                }
              )
              Object.assign(row, { itemStatusCal })
            })
            this.taskData.checklist.map((row, index) => {
              const showTextBox = []
              Object.assign(row, { showTextBox })
            })
            this.taskData.from_time = task.from_time
            this.taskData.to_time = task.to_time
            this.logHistory = []
            for (let index = 0; index < task.logs.length; index++) {
              this.logHistory.push({
                no_of_days: task.logs[index].no_of_days,
                no_of_hours: task.logs[index].no_of_hours
              })
            }
            this.taskData.is_template = false
            this.taskData.details = task.details
            // this.taskData.details = task.project.id;
            this.taskData.clientObserver = task.clientObserver
            this.taskData.clientParticipant = task.clientParticipant
            this.taskData.clientResponsiblePerson =
              task.clientResponsiblePerson
            this.taskData.userObserver = task.userObserver
            this.taskData.userParticipant = task.userParticipant

            this.selectedSubTaskData = task.subtask
            this.showDataForProject = task.project
            for (let index = 0; index < task.tags.length; index++) {
              this.taskData.tags.push(task.tags[index].id)
            }
            this.selectedCRMData = task.leads
            if (task.taskReminder.length !== 0) {
              for (let index = 0; index < task.taskReminder.length; index++) {
                this.addReminder()
              }
              for (let index = 0; index < task.taskReminder.length; index++) {
                this.reminderTime[index].id = task.taskReminder[index].id
                this.reminderTime[index].reminder_time =
                  task.taskReminder[index].reminder_time
              }
            }
          })
          .catch((e) => {})
        this.openUpdateModal = true
      }
    },
    updateTaskDataLiveFromProject () {
      if (
        this.taskData.is_template === '1' ||
        this.taskData.is_template === true
      ) {
        this.taskData.is_template = true
      } else {
        this.taskData.is_template = false
      }
      this.taskData.userResponsiblePerson = []
      this.taskData.clientResponsiblePerson = []
      if (this.responsibleData.length !== 0) {
        for (let i = 0; i < this.responsibleData.length; i++) {
          if ('user_type' in this.responsibleData[i]) {
            if (this.responsibleData[i].user_type === 0) {
              this.taskData.userResponsiblePerson.push(
                this.responsibleData[i].users_id
              )
            } else {
              this.taskData.clientResponsiblePerson.push(
                this.responsibleData[i].users_id
              )
            }
          }
          if ('pivot' in this.responsibleData[i]) {
            if (this.responsibleData[i].pivot.responsible_persons_type === 0) {
              this.taskData.userResponsiblePerson.push(
                this.responsibleData[i].pivot.responsible_persons_id
              )
            } else {
              this.taskData.clientResponsiblePerson.push(
                this.responsibleData[i].pivot.responsible_persons_id
              )
            }
          }
        }
      }
      this.taskData.userParticipant = []
      this.taskData.clientParticipant = []
      if (this.participantData.length !== 0) {
        for (let i = 0; i < this.participantData.length; i++) {
          if ('user_type' in this.participantData[i]) {
            console.log(this.participantData[i].user_type)
            if (this.participantData[i].user_type === 0) {
              this.taskData.userParticipant.push(
                this.participantData[i].users_id
              )
            } else {
              this.taskData.clientParticipant.push(
                this.participantData[i].users_id
              )
            }
          }
          if ('pivot' in this.participantData[i]) {
            if (this.participantData[i].pivot.participants_type === 0) {
              this.taskData.userParticipant.push(
                this.participantData[i].pivot.participants_id
              )
            } else {
              this.taskData.clientParticipant.push(
                this.participantData[i].pivot.participants_id
              )
            }
          }
        }
      }
      this.taskData.userObserver = []
      this.taskData.clientObserver = []
      if (this.observerData.length !== 0) {
        for (let i = 0; i < this.observerData.length; i++) {
          if ('user_type' in this.observerData[i]) {
            if (this.observerData[i].user_type === 0) {
              this.taskData.userObserver.push(this.observerData[i].users_id)
            } else {
              this.taskData.clientObserver.push(this.observerData[i].users_id)
            }
          }
          if ('pivot' in this.observerData[i]) {
            if (this.observerData[i].pivot.observers_type === 0) {
              this.taskData.userObserver.push(
                this.observerData[i].pivot.observers_id
              )
            } else {
              this.taskData.clientObserver.push(
                this.observerData[i].pivot.observers_id
              )
            }
          }
        }
      }
      if (
        this.checklistRows.length !== 0 ||
        this.taskData.checklist.length !== 0
      ) {
        for (let index = 0; index < this.taskData.checklist.length; index++) {
          if ('todos' in this.taskData.checklist[index]) {
            for (
              let j = 0;
              j < this.taskData.checklist[index].todos.length;
              j++
            ) {
              this.taskData.checklist[index].todos[j].order_id = j + 1
            }
            if (this.taskData.checklist[index].todos.length === 0) {
              this.taskData.checklist.splice(index, 1)
            }
          }
        }
        for (let index = 0; index < this.checklistRows.length; index++) {
          if (this.checklistRows[index].items.length === 0) {
            this.checklistRows.splice(index, 1)
          } else {
            const result = this.checklistRows[index].items.map(function (el) {
              const o = Object.assign({}, el)
              o.order_id = 0
              return o
            })
            for (let j = 0; j < result.length; j++) {
              this.checklistRows[index].items[j].order_id = j + 1
            }
            this.taskData.checklist.push({
              name: this.checklistRows[index].name,
              todos: this.checklistRows[index].items
            })
          }
        }
      }

      if (this.selectedSubTaskData.length !== 0) {
        for (let i = 0; i < this.selectedSubTaskData.length; i++) {
          this.taskData.subtask.push(this.selectedSubTaskData[i].id)
        }
      }
      if (this.selectedCRMData.length !== 0) {
        for (let i = 0; i < this.selectedCRMData.length; i++) {
          this.taskData.leads.push(this.selectedCRMData[i].leads_id)
        }
      }
      if (this.reminderTime.length !== 0) {
        for (let i = 0; i < this.reminderTime.length; i++) {
          this.taskData.reminder.push({
            id: this.reminderTime[i].id,
            reminder_type: 1,
            reminder_time: this.reminderTime[i].reminder_time
          })
        }
      }
      const payload = {
        updateField: this.taskData
      }
      taskUpdate(
        localStorage.getItem('customer_id'),
        this.live_update_id,
        payload
      )
        .then((res) => {
          const afterUpdate = res.data.data.task
          //const afterChange = projectStatusData.tasks.map(obj => afterUpdate.find(o => o.id === obj.id) || obj)
          const objIndex = this.projectDetailsData.findIndex(
            (obj) => obj.id === this.projectStatusId
          )
          const objTaskIndex = this.projectDetailsData[
            objIndex
          ].tasks.findIndex((obj) => obj.id === this.live_update_id)
          this.projectDetailsData[objIndex].tasks[objTaskIndex] = afterUpdate
          this.successPopupMessage('Task Updated Successfully')
          this.openUpdateModal = false
          this.clearData()
        })
        .catch((e) => {
          this.openUpdateModal = false
          this.clearData()
          this.warningPopupMessage('Something Went Wrong')
        })
    },
    updateKanbanBoard (data) {
      this.getAllTask()
    },
    updateStatusName (data) {
      const objIndex = this.projectDetailsData.findIndex(
        (obj) => obj.id === data.id
      )
      this.projectDetailsData[objIndex].name = data.name
      this.saveTheReorder('update')
    },
    removeStatus (data) {
      const objIndex = this.projectDetailsData.findIndex(
        (obj) => obj.id === data.id
      )
      this.projectDetailsData.splice(objIndex, 1)
      this.saveTheReorder('delete')
    },
    addStatusInProject () {
      if (this.addedStatus !== '') {
        this.projectDetailsData.push({ name: this.addedStatus, id: null })
        const projectData = {
          projectStatusTag: []
        }
        for (let i = 0; i < this.projectDetailsData.length; i++) {
          projectData.projectStatusTag.push({
            id: this.projectDetailsData[i].id,
            name: this.projectDetailsData[i].name,
            weighted_order_id: i + 1
          })
        }
        const payload = {
          updateField: projectData
        }
        this.updateProj(payload, 'added')
      }
    },
    saveTheReorder (fromWhere = '') {
      const projectData = {
        projectStatusTag: []
      }
      for (let i = 0; i < this.projectDetailsData.length; i++) {
        projectData.projectStatusTag.push({
          id: this.projectDetailsData[i].id,
          name: this.projectDetailsData[i].name,
          weighted_order_id: i + 1
        })
      }
      const payload = {
        updateField: projectData
      }
      //console.log(this.projectDetailsData)
      this.updateProj(payload, fromWhere)
    },
    updateProj (data, fromWhere = '') {
      projectUpdate(
        localStorage.getItem('customer_id'),
        this.$route.params.id,
        data
      )
        .then((res) => {
          if (this.addedStatus !== '') {
            const objIndex = this.projectDetailsData.findIndex(
              (item) => item.name == this.addedStatus
            )
            this.projectDetailsData[objIndex].id =
              res.data.data.project.projectStatusTag[objIndex].id
            this.projectDetailsData[objIndex].tasks = []
          }
          this.reorderStatus = false
          this.addBoardPopup = false
          this.addedStatus = ''
          if (fromWhere === 'reorder') {
            this.successPopupMessage('Status Reordered Successfully')
          } else if (fromWhere === 'delete') {
            this.successPopupMessage('Status Removed Successfully')
          } else if (fromWhere === 'added') {
            this.successPopupMessage('Status Added Successfully')
          } else if (fromWhere === 'update') {
            this.successPopupMessage('Status Updated Successfully')
          }
        })
        .catch((e) => {})
    },
    StatusChnage (data) {
      if (this.projectDetails.platform_project_completion_status.id !== 3) {
        const payload = {
          updateField: { task_status_id: data.task_status_id }
        }
        taskUpdate(
          localStorage.getItem('customer_id'),
          this.live_update_id,
          payload
        )
          .then((res) => {
            const afterUpdate = res.data.data.task
            const objIndex = this.projectDetailsData.findIndex(
              (obj) => obj.id === this.projectStatusTagId.id
            )
            const objTaskIndex = this.projectDetailsData[
              objIndex
            ].tasks.findIndex((obj) => obj.id === this.live_update_id)
            this.projectDetailsData[objIndex].tasks[objTaskIndex].status.id =
              afterUpdate.status.id
            this.projectDetailsData[objIndex].tasks[
              objTaskIndex
            ].status.status = afterUpdate.status.status
            this.warningPopupShow2 = false
          })
          .catch((e) => {})
      } else {
        this.warningPopupMessage(
          'You can\'t change task status of a complete project'
        )
      }
    },
    checkStatus () {
      taskStatusCheck(
        localStorage.getItem('customer_id'),
        this.$route.params.id
      )
        .then((res) => {
          this.statusData = res.data.data.task
          for (let index = 0; index < this.statusData.length; index++) {
            this.todo = this.statusData.filter((ele) => {
              return ele.status.id === 1
            })
            this.inProgress = this.statusData.filter((ele) => {
              return ele.status.id === 2
            })
          }
        })
        .catch((e) => {})

      this.warningPopupShow = false
      this.warningPopupShow2 = true
    },

    completeProject () {
      const payload = {
        updateField: { platform_project_completion_status_id: 3 }
      }
      projectUpdate(
        localStorage.getItem('customer_id'),
        this.$route.params.id,
        payload
      )
        .then((res) => {
          const afterUpdate = res.data.data.project
          this.projectDetails.platform_project_completion_status.id =
            afterUpdate.platform_project_completion_status.id
          this.warningPopupShow2 = false
          this.successPopupMessage('Project Completed Successfully')
        })
        .catch((e) => {
          this.warningPopupMessage('Something Went Wrong')
        })
    },

    getAllTask () {
      this.$vs.loading({ type: 'radius' })
      projectKanbanShow(
        localStorage.getItem('customer_id'),
        this.$route.params.id
      )
        .then((res) => {
          this.projectDetailsData = res.data.data.project_status
          this.projectDetails.platform_project_completion_status.id =
            res.data.data.project.platform_project_completion_status.id
          this.projectDetails.name = res.data.data.project.name
          this.projectDetails.details = res.data.data.project.details
          this.projectDetails.userProjectMember =
            res.data.data.project.userProjectMember
          this.projectDetails.clientProjectMember =
            res.data.data.project.clientProjectMember
          this.projectDetails.due_date = res.data.data.project.due_date
          this.$vs.loading.close()
        })
        .catch((e) => {
          this.$vs.loading.close()
        })
    },
    checkMove (evt) {
      // console.log('move evt -->', evt)
      if (this.checkProjectEditPermission() === true) {
        const id = evt.draggedContext.element.id
        const changestatusTo = evt.to.id
        const payload = {
          updateField: {
            project_status_id: changestatusTo
          }
        }

        if (evt.from.id !== evt.to.id) {
          this.kanbanStatusUpdate(id, payload)
        }
      } else {
        this.warningPopupMessage('You don\'t have edit permission')
      }
    },
    async handleKanbanReorder (event) {
      if (this.checkProjectEditPermission() !== true) return

      const from_id = event.from.id
      const to_id = event.to.id

      // console.log('FROM ->', from_id)
      // console.log('TO ->', to_id)

      let kanban_reorder_payload = []

      this.projectDetailsData.find((detail) => {
        if (detail.id === +from_id) {
          kanban_reorder_payload = detail.tasks.map((task, idx) => {
            return {
              task_id: task.id,
              project_status_id: detail.id,
              order_id: idx
            }
          })
        }
      })

      if (from_id !== to_id) {
        this.projectDetailsData.find((detail) => {
          if (detail.id === +to_id) {
            detail.tasks.map((task, idx) => {
              kanban_reorder_payload.push({
                task_id: task.id,
                project_status_id: detail.id,
                order_id: idx
              })
            })
          }
        })
      }

      // console.log(kanban_reorder_payload)
      await kanbanReorder(
        this.$route.params.id,
        localStorage.getItem('customer_id'),
        { kanban: kanban_reorder_payload }
      )
    },
    async kanbanStatusUpdate (id, payload) {
      try {
        await taskUpdate(localStorage.getItem('customer_id'), id, payload)
        this.successPopupMessage('Task updated')
      } catch (apiError) {
        this.warningPopupMessage('Something Went Wrong')
      }
    },
    tabView (type) {
      if (type === 'todo') {
        this.todoTab = true
        this.progressTab = false
      } else if (type === 'progress') {
        this.todoTab = false
        this.progressTab = true
      }
    }
  }
}
</script>
<style scoped>
.customSelect {
  border-radius: 3px;
  border: 1px solid #cccccc;
  width: 100%;
  height: 30px;
  background-color: white;
  color: #757575;
  /* font-family: $font-family-base'; */
}
.selectOptionclass :hover {
  background-color: yellow;
  color: white;
  border: none;
}
</style>
<style>
input.dateformatChng.form-control.input {
  border: none;
  background: white;
}
.reorderPopup .vs-popup--content {
  padding: 0 1rem;
}
.addBoardbtn .material-icons {
  font-size: 25px;
}
.addBoardTooltip {
  background: transparent !important;
  padding: 0 !important;
  width: auto !important;
  min-width: auto !important;
  max-width: inherit !important;
}
.w_210_input + input {
  min-width: 210px;
  text-align: right;
  padding: 0 !important;
}
.card_content_pb_0 .vs-card--content {
  padding-bottom: 0 !important;
}
</style>
